/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.3.2
 * @since 1.0.0
 */

import { css } from 'styled-components';
import theme from 'styled-theming';

import { ESkeletonKind } from './skeletonTypes';
import { bigLoaderShimmer, smallLoaderShimmer } from './styled/SkeletonStyled';

/*
* -------------------------------------------
*           SKELETON ANIMATION
* -------------------------------------------
*/

export const animationName = theme.variants('mode', 'kind', {
    [ESkeletonKind.BUTTON_ROUND]: { standard: css`${bigLoaderShimmer}` },
    [ESkeletonKind.CHART_DONUT]: { standard: css`${bigLoaderShimmer}` },
    [ESkeletonKind.PARAGRAPH_NORMAL]: { standard: css`${bigLoaderShimmer}` },
    [ESkeletonKind.PARAGRAPH_SMALL]: { standard: css`${smallLoaderShimmer}` },
});

export const animationDuration = theme.variants('mode', 'kind', {
    [ESkeletonKind.BUTTON_ROUND]: { standard: '5s' },
    [ESkeletonKind.CHART_DONUT]: { standard: '5s' },
    [ESkeletonKind.PARAGRAPH_NORMAL]: { standard: '5s' },
    [ESkeletonKind.PARAGRAPH_SMALL]: { standard: '5s' },
});

/*
* -------------------------------------------
*           SKELETON BLOCK
* -------------------------------------------
*/

export const height = theme.variants('mode', 'kind', {
    [ESkeletonKind.BUTTON_ROUND]: { standard: '32px' },
    [ESkeletonKind.CHART_DONUT]: { standard: '226px' },
    [ESkeletonKind.PARAGRAPH_NORMAL]: { standard: '12px' },
    [ESkeletonKind.PARAGRAPH_SMALL]: { standard: '12px' },
});

export const width = theme.variants('mode', 'kind', {
    [ESkeletonKind.BUTTON_ROUND]: { standard: '100%' },
    [ESkeletonKind.CHART_DONUT]: { standard: '226px' },
    [ESkeletonKind.PARAGRAPH_NORMAL]: { standard: '100%' },
    [ESkeletonKind.PARAGRAPH_SMALL]: { standard: '210px' },
});

export const buttonBorderRadius = theme.variants('mode', 'kind', {
    [ESkeletonKind.BUTTON_ROUND]: { standard: '16px' },
    [ESkeletonKind.CHART_DONUT]: { standard: '50%' },
    [ESkeletonKind.PARAGRAPH_NORMAL]: { standard: '50%' },
    [ESkeletonKind.PARAGRAPH_SMALL]: { standard: '50%' },
});

